var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37, _rect38, _rect39, _rect40, _rect41, _rect42, _rect43, _rect44, _rect45, _rect46, _rect47, _rect48, _rect49;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBackOfCard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 172 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 171,
    height: 92.1128,
    rx: 7.5,
    fill: "white",
    stroke: "#D8D8D8"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 96,
    y: 11,
    width: 0.5,
    height: 11,
    fill: "#C2C2C2"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 97.5,
    y: 11,
    width: 0.5,
    height: 11,
    fill: "#C2C2C2"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 99,
    y: 11,
    width: 0.5,
    height: 11,
    fill: "#C2C2C2"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 100.5,
    y: 11,
    width: 0.5,
    height: 11,
    fill: "#C2C2C2"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 102,
    y: 11,
    width: 0.5,
    height: 11,
    fill: "#C2C2C2"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 103.5,
    y: 11,
    width: 0.5,
    height: 11,
    fill: "#C2C2C2"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 105,
    y: 11,
    width: 0.5,
    height: 11,
    fill: "#C2C2C2"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 106.5,
    y: 11,
    width: 0.5,
    height: 11,
    fill: "#C2C2C2"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 108,
    y: 11,
    width: 0.5,
    height: 11,
    fill: "#C2C2C2"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 109.5,
    y: 11,
    width: 0.5,
    height: 11,
    fill: "#C2C2C2"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 111,
    y: 11,
    width: 0.5,
    height: 11,
    fill: "#C2C2C2"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 112.5,
    y: 11,
    width: 0.5,
    height: 11,
    fill: "#C2C2C2"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 114,
    y: 11,
    width: 0.5,
    height: 11,
    fill: "#C2C2C2"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 115.5,
    y: 11,
    width: 0.5,
    height: 11,
    fill: "#C2C2C2"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 117,
    y: 11,
    width: 0.5,
    height: 11,
    fill: "#C2C2C2"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 118.5,
    y: 11,
    width: 0.5,
    height: 11,
    fill: "#C2C2C2"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 11,
    width: 0.5,
    height: 11,
    fill: "#C2C2C2"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 121.5,
    y: 11,
    width: 0.5,
    height: 11,
    fill: "#C2C2C2"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 123,
    y: 11,
    width: 0.5,
    height: 11,
    fill: "#C2C2C2"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 124.5,
    y: 11,
    width: 0.5,
    height: 11,
    fill: "#C2C2C2"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 126,
    y: 11,
    width: 0.5,
    height: 11,
    fill: "#C2C2C2"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 127.5,
    y: 11,
    width: 0.5,
    height: 11,
    fill: "#C2C2C2"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 131,
    y: 11,
    width: 0.5,
    height: 11,
    fill: "#C2C2C2"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 132.5,
    y: 11,
    width: 0.5,
    height: 11,
    fill: "#C2C2C2"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 134,
    y: 11,
    width: 0.5,
    height: 11,
    fill: "#C2C2C2"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 135.5,
    y: 11,
    width: 0.5,
    height: 11,
    fill: "#C2C2C2"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 137,
    y: 11,
    width: 0.5,
    height: 11,
    fill: "#C2C2C2"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 138.5,
    y: 11,
    width: 0.5,
    height: 11,
    fill: "#C2C2C2"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 140,
    y: 11,
    width: 0.5,
    height: 11,
    fill: "#C2C2C2"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 141.5,
    y: 11,
    width: 0.5,
    height: 11,
    fill: "#C2C2C2"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 143,
    y: 11,
    width: 0.5,
    height: 11,
    fill: "#C2C2C2"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 144.5,
    y: 11,
    width: 0.5,
    height: 11,
    fill: "#C2C2C2"
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 146,
    y: 11,
    width: 0.5,
    height: 11,
    fill: "#C2C2C2"
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 147.5,
    y: 11,
    width: 0.5,
    height: 11,
    fill: "#C2C2C2"
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 149,
    y: 11,
    width: 0.5,
    height: 11,
    fill: "#C2C2C2"
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    x: 150.5,
    y: 11,
    width: 0.5,
    height: 11,
    fill: "#C2C2C2"
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    x: 152,
    y: 11,
    width: 0.5,
    height: 11,
    fill: "#C2C2C2"
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    x: 153.5,
    y: 11,
    width: 0.5,
    height: 11,
    fill: "#C2C2C2"
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    x: 155,
    y: 11,
    width: 0.5,
    height: 11,
    fill: "#C2C2C2"
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    x: 156.5,
    y: 11,
    width: 0.5,
    height: 11,
    fill: "#C2C2C2"
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    x: 158,
    y: 11,
    width: 0.5,
    height: 11,
    fill: "#C2C2C2"
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    x: 159.5,
    y: 11,
    width: 0.5,
    height: 11,
    fill: "#C2C2C2"
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 35,
    width: 121,
    height: 6,
    fill: "#D8D8D8"
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 44,
    width: 121,
    height: 6,
    fill: "#D8D8D8"
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 53,
    width: 121,
    height: 5,
    fill: "#D8D8D8"
  })), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 61,
    width: 121,
    height: 6,
    fill: "#D8D8D8"
  })), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 76,
    width: 36,
    height: 6,
    fill: "#C2C2C2"
  })), _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    x: 110,
    y: 76,
    width: 36,
    height: 6,
    fill: "#C2C2C2"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackOfCard);
export default __webpack_public_path__ + "static/media/back-of-card.f9ae59b4.svg";
export { ForwardRef as ReactComponent };